import AttachmentListView from './AttachmentListView';

export default AttachmentListView;
